import { c as _c } from "react/compiler-runtime";
import useChatMessageStore from '@module/stores/useChatMessageStore';
import { useFetchLivePlayMutationStore } from '@module/stores/useFetchLivePlayMutationStore';
import type { BookmarkAlertMessage } from '@module/types/centrifuge/public-message';
import TimeConstants from '@module/utils/item';
import { useEffect } from 'react';
import useGetLoginInfoQuery from '../auth/useGetLoginInfoQuery';

/**
 * @description 채팅에 북마크 유도 메시지 5분마다 추가하는 훅
 */
function useInduceBookmark() {
  const $ = _c(8);
  const {
    isLogin
  } = useGetLoginInfoQuery();
  const {
    data: playInfo
  } = useFetchLivePlayMutationStore();
  const setChatMessages = useChatMessageStore(_temp);
  let t0;
  if ($[0] !== isLogin || $[1] !== playInfo?.isBookmark || $[2] !== setChatMessages) {
    t0 = () => {
      if (!isLogin || !playInfo?.isBookmark) {
        const bookmarkGuideTimer = setTimeout(() => {
          setChatMessages(_temp2);
        }, TimeConstants.FIVE_MINUTES);
        return () => clearTimeout(bookmarkGuideTimer);
      }
    };
    $[0] = isLogin;
    $[1] = playInfo?.isBookmark;
    $[2] = setChatMessages;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const t1 = playInfo?.isBookmark;
  let t2;
  if ($[4] !== isLogin || $[5] !== setChatMessages || $[6] !== t1) {
    t2 = [isLogin, t1, setChatMessages];
    $[4] = isLogin;
    $[5] = setChatMessages;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t0, t2);
}
function _temp2(prev) {
  const now = Date.now();
  const bookmarkAlertPayload = {
    data: {
      type: "BookmarkAlert",
      message: ""
    },
    offset: now
  };
  return [...prev, bookmarkAlertPayload];
}
function _temp(state) {
  return state.setChatMessages;
}
export default useInduceBookmark;